"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Publishable = exports.PostInCategory = exports.Paywalled = exports.Passage = exports.Paragraph = exports.Page = exports.Module = exports.Image = exports.Excerpt = exports.Entry = exports.Embeddable = exports.Email = exports.Course = exports.Concept = exports.Chapter = exports.Category = exports.Bulletin = exports.Book = exports.Blog = exports.Block = exports.Author = exports.AspectOfWiki = exports.Analysis = void 0;
Object.defineProperty(exports, "PublishingStatus", {
  enumerable: true,
  get: function () {
    return _publishingStatus.PublishingStatus;
  }
});
exports.getOrderingValue = exports.filterBlockDynamically = exports.Wiki = exports.Tracking = exports.Tag = exports.Subscription = exports.Story = exports.SourceFile = exports.SourceAuthor = exports.Source = exports.Session = exports.Referenceable = exports.Quote = exports.Questionnaire = void 0;
var _Page = _interopRequireWildcard(require("./cloud/nosql/page"));
exports.Page = _Page;
var _Course = _interopRequireWildcard(require("./cloud/nosql/course"));
exports.Course = _Course;
var _Entry = _interopRequireWildcard(require("./cloud/nosql/entry"));
exports.Entry = _Entry;
var _Author = _interopRequireWildcard(require("./cloud/nosql/author"));
exports.Author = _Author;
var _Blog = _interopRequireWildcard(require("./cloud/nosql/blog"));
exports.Blog = _Blog;
var _Category = _interopRequireWildcard(require("./cloud/nosql/category"));
exports.Category = _Category;
var _PostInCategory = _interopRequireWildcard(require("./cloud/nosql/postInCategory"));
exports.PostInCategory = _PostInCategory;
var _Session = _interopRequireWildcard(require("./cloud/nosql/session"));
exports.Session = _Session;
var _Email = _interopRequireWildcard(require("./cloud/nosql/email"));
exports.Email = _Email;
var _Paywalled = _interopRequireWildcard(require("./cloud/nosql/paywalled"));
exports.Paywalled = _Paywalled;
var _Subscription = _interopRequireWildcard(require("./cloud/nosql/subscription"));
exports.Subscription = _Subscription;
var _Tracking = _interopRequireWildcard(require("./cloud/nosql/tracking"));
exports.Tracking = _Tracking;
var _Bulletin = _interopRequireWildcard(require("./cloud/nosql/bulletin"));
exports.Bulletin = _Bulletin;
var _Questionnaire = _interopRequireWildcard(require("./cloud/nosql/questionnaire"));
exports.Questionnaire = _Questionnaire;
var _Analysis = _interopRequireWildcard(require("./cloud/nosql/analysis"));
exports.Analysis = _Analysis;
var _Wiki = _interopRequireWildcard(require("./cloud/nosql/wiki"));
exports.Wiki = _Wiki;
var _AspectOfWiki = _interopRequireWildcard(require("./cloud/nosql/aspectOfWiki"));
exports.AspectOfWiki = _AspectOfWiki;
var _Passage = _interopRequireWildcard(require("./cloud/nosql/passage"));
exports.Passage = _Passage;
var _publishingStatus = require("./cloud/nosql/publishingStatus");
var _block = _interopRequireWildcard(require("./server/block"));
var _Block = _block;
exports.Block = _block;
var _source = _interopRequireWildcard(require("./server/source"));
var _Source = _source;
exports.Source = _source;
var _quote = _interopRequireWildcard(require("./server/quote"));
var _Quote = _quote;
exports.Quote = _quote;
var _excerpt = _interopRequireWildcard(require("./server/excerpt"));
var _Excerpt = _excerpt;
exports.Excerpt = _excerpt;
var _SourceAuthor = _interopRequireWildcard(require("./server/sourceauthor"));
exports.SourceAuthor = _SourceAuthor;
var _SourceFile = _interopRequireWildcard(require("./server/sourcefile"));
exports.SourceFile = _SourceFile;
var _Image = _interopRequireWildcard(require("./server/image"));
exports.Image = _Image;
var _story = _interopRequireWildcard(require("./server/story"));
var _Story = _story;
exports.Story = _story;
var _module = _interopRequireWildcard(require("./server/module"));
var _Module = _module;
exports.Module = _module;
var _concept = _interopRequireWildcard(require("./server/concept"));
var _Concept = _concept;
exports.Concept = _concept;
var _paragraph = _interopRequireWildcard(require("./server/paragraph"));
var _Paragraph = _paragraph;
exports.Paragraph = _paragraph;
var _Publishable = _interopRequireWildcard(require("./server/publishable"));
exports.Publishable = _Publishable;
var _Embeddable = _interopRequireWildcard(require("./server/embeddable"));
exports.Embeddable = _Embeddable;
var _Referenceable = _interopRequireWildcard(require("./server/referenceable"));
exports.Referenceable = _Referenceable;
var _book = _interopRequireWildcard(require("./server/book"));
var _Book = _book;
exports.Book = _book;
var _chapter = _interopRequireWildcard(require("./server/chapter"));
var _Chapter = _chapter;
exports.Chapter = _chapter;
var _Tag = _interopRequireWildcard(require("./server/tag"));
exports.Tag = _Tag;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* this requires path. but t also should work in the browser

import * as glob from 'glob';


// Define the root folder path
const rootFolderPath = `${__dirname}`;


// Use glob to find all the TypeScript files in the folder and its subfolders
const files = glob.sync('** /*.js', { cwd: rootFolderPath });

// Export everything from each file
files.forEach((file) => {
    
    const module = require(`${rootFolderPath}/${file}`);
    Object.keys(module).forEach((exportedItem) => {
        exports[exportedItem] = module[exportedItem];
    });
});
*/

const filterBlockDynamically = (data, {
  fallback = {},
  override = {}
} = {}, collect) => {
  return (0, _block.filterBlock)(data, {
    fallback: fallback,
    override: function () {
      if (data.blockType === _block.BLOCKTYPE.CONCEPT) {
        return (0, _concept.filterConcept)(data, {
          fallback,
          override
        }, collect);
      } else if (data.blockType === _block.BLOCKTYPE.PARAGRAPH) {
        return (0, _paragraph.filterParagraph)(data, {
          fallback,
          override
        }, collect);
      } else if (data.blockType === _block.BLOCKTYPE.MODULE) {
        return (0, _module.filterModule)(data, {
          fallback,
          override
        }, collect);
      } else if (data.blockType === _block.BLOCKTYPE.STORY) {
        return (0, _story.filterStory)(data, {
          fallback,
          override
        }, collect);
      } else if (data.blockType === _block.BLOCKTYPE.SOURCE) {
        return (0, _source.filterSource)(data, {
          fallback,
          override
        }, collect);
      } else if (data.blockType === _block.BLOCKTYPE.QUOTE) {
        return (0, _quote.filterQuote)(data, {
          fallback,
          override
        }, collect);
      } else if (data.blockType === _block.BLOCKTYPE.BOOK) {
        return (0, _book.filterBook)(data, {
          fallback,
          override
        }, collect);
      } else if (data.blockType === _block.BLOCKTYPE.CHAPTER) {
        return (0, _chapter.filterChapter)(data, {
          fallback,
          override
        }, collect);
      } else if (data.blockType === _block.BLOCKTYPE.EXCERPT) {
        return (0, _excerpt.filterExcerpt)(data, {
          fallback,
          override
        }, collect);
      }
      return override;
    }()
  }, collect);
};
exports.filterBlockDynamically = filterBlockDynamically;
const getOrderingValue = (lowerValue, upperValue) => {
  const order = '0123456789abcdefghijklmnopqrstuvwxyz';

  // this should not happen - two identical positions. There is no correct solution, 
  // but this one prevents crashing
  if (upperValue && (lowerValue === null || lowerValue === void 0 ? void 0 : lowerValue.localeCompare(upperValue)) == 0) {
    return `${lowerValue}h`;
  }
  //console.log("compare ", lowerValue, upperValue)

  // 0 is falsy!

  const lowerPos = typeof lowerValue === "string" && lowerValue[0] !== undefined ? order.indexOf(lowerValue[0]) : 0;
  const upperPos = typeof upperValue === "string" && upperValue[0] !== undefined ? order.indexOf(upperValue[0]) : order.length - 1;
  const difference = upperPos - lowerPos;
  if (difference < 2) {
    var _upperValue$length, _lowerValue$length;
    // use the lower value
    //console.log("DIFFERENCE", lowerValue, upperValue)
    return `${order.charAt(lowerPos)}${getOrderingValue(lowerValue === null || lowerValue === void 0 ? void 0 : lowerValue.slice(1), difference === 0 || ((_upperValue$length = upperValue === null || upperValue === void 0 ? void 0 : upperValue.length) !== null && _upperValue$length !== void 0 ? _upperValue$length : 0) > ((_lowerValue$length = lowerValue === null || lowerValue === void 0 ? void 0 : lowerValue.length) !== null && _lowerValue$length !== void 0 ? _lowerValue$length : 0) ? upperValue === null || upperValue === void 0 ? void 0 : upperValue.slice(1) : null)}`;
  } else {
    return order.charAt(difference / 2 + lowerPos);
  }

  //console.log(lowerValue, upperValue, lowerPos, upperPos, (upperPos-lowerPos)/2, result)
};
exports.getOrderingValue = getOrderingValue;